import { getStore } from '@/store'

import { qrListAtom } from './tableState'

export const patchQrPasswordInList = (qrId: string, hasPassword: boolean) => {
	const qrList = getStore().get(qrListAtom)
	getStore().set(
		qrListAtom,
		qrList.map((qr) => (qr.id === qrId ? { ...qr, hasPassword } : qr)),
	)
}
